module.exports = __webpack_public_path__ + "static/img/kols14.af42f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols/kols14.png
// module id = YOh3
// module chunks = 0